<template>
  <ol class="questions">
    <li>
      <fieldset>
        <legend>
          <span class="label">Select your local government area</span>
          <abbr class="required" name="label-lga" title="(required)">*</abbr>
        </legend>
        <ul class="choices">
          <li v-for="(location, index) in selectedArea.locations" :key="index">
            <ValidationProvider rules="required:#label-lga">
              <input
                :id="'declared-area-' + index"
                v-model="declaredLocalArea"
                :value="location"
                name="Select your local government area"
                type="radio"
              />
            </ValidationProvider>
            <label :for="'declared-area-' + index">{{ location }}</label>
          </li>
        </ul>
      </fieldset>
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    areas: Array,
    value: String,
  },
  computed: {
    selectedArea: function() {
      return this.areas.filter((area) => area.selected)[0] ?? [];
    },
    declaredLocalArea: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
